/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Phonenumber1Inputs */

const en_common_phonenumber1 = /** @type {(inputs: Common_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Common_Phonenumber1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_phonenumber1 = /** @type {((inputs?: Common_Phonenumber1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Phonenumber1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_phonenumber1(inputs)
});
export { common_phonenumber1 as "common_phoneNumber" }